import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AgentReportReducer } from '../reducers';

export const selectAgentReportFeature = createFeatureSelector<AgentReportReducer.AgentReportState>(AgentReportReducer.featureName);

export const selectAgentReport = createSelector(selectAgentReportFeature, (state: AgentReportReducer.AgentReportState) => state.item);
